module.exports = __webpack_public_path__ + "static/media/news.3805a785.svg";